var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.73333C0.5 0.77604 1.2931 0 2.27143 0H19.1V6.93333H2.27143C1.2931 6.93333 0.5 6.15729 0.5 5.2V1.73333Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7571 0H29.7286C30.7069 0 31.5 0.77604 31.5 1.73333V5.2C31.5 6.15729 30.7069 6.93333 29.7286 6.93333H21.7571V0Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2429 19.0667H2.27143C1.2931 19.0667 0.5 19.8427 0.5 20.8V24.2667C0.5 25.224 1.2931 26 2.27143 26H10.2429V19.0667Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 19.0667H29.7286C30.7069 19.0667 31.5 19.8427 31.5 20.8V24.2667C31.5 25.224 30.7069 26 29.7286 26H12.9V19.0667Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27143 11.2667C2.27143 10.3094 3.06452 9.53333 4.04286 9.53333H27.9571C28.9355 9.53333 29.7286 10.3094 29.7286 11.2667V14.7333C29.7286 15.6906 28.9355 16.4667 27.9571 16.4667H4.04286C3.06452 16.4667 2.27143 15.6906 2.27143 14.7333V11.2667Z",
    fill: "#9B9B9B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLogo);
export default __webpack_public_path__ + "static/media/gridLogo.426be5df7b00c68308a8e65ecf29835a.svg";
export { ForwardRef as ReactComponent };